import { Box, BoxProps } from "@mui/material";
import { FC, ReactNode } from "react";

interface CenteredCellProps extends Omit<BoxProps, "children"> {
  children: ReactNode;
  justifyContent?: "center" | "flex-start" | "flex-end" | "space-between" | "space-around";
}

export const CenteredCell: FC<CenteredCellProps> = ({ children, justifyContent, sx, ...rest }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        ...(justifyContent && { justifyContent }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
